export const anwereChoicesList = [
  { key: "A", title: "Sehr typisch für mich" },
  { key: "B", title: "Eher typisch für mich" },
  { key: "C", title: "Einigermaßen typisch für mich" },
  { key: "D", title: "Eher untypisch für mich" },
  { key: "E", title: "Sehr untypisch für mich" },
];
